// Microsoft Clarity — PUBLIC marketing analytics ONLY.
//
// IMPORTANT: never load this in the authenticated product app. The app renders patient reports
// (PHI) and Clarity does session replay (it records the DOM). This loader is called only from the
// marketing Landing ("/") and it additionally skips signed-in users, so recordings stay limited to
// anonymous marketing visitors. Pair this with Clarity dashboard masking (Settings -> Masking ->
// "Mask" All) as defense-in-depth.
//
// Project id: baked-in DEFAULT_PROJECT_ID so marketing analytics work out of the box on any
// deploy (Vercel, Docker, etc.) without an extra build-time env var. Clarity project ids ship in
// the client bundle to every visitor anyway, so committing this is not a secret leak. The env var
// REACT_APP_CLARITY_PROJECT_ID still wins if set (useful for a separate staging Clarity project).
const DEFAULT_PROJECT_ID = "xpbpalh2g5";
let loaded = false;

export function loadClarity(): void {
  const id = process.env.REACT_APP_CLARITY_PROJECT_ID || DEFAULT_PROJECT_ID;
  if (loaded) return;
  // Do not record signed-in users — they can navigate into PHI screens. `auth_user` is the same
  // client-side auth marker ProtectedRoute uses.
  if (typeof window !== "undefined" && window.sessionStorage.getItem("auth_user")) return;
  loaded = true;
  (function (c: any, l: Document, a: string, r: string, i: string) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    const t = l.createElement(r) as HTMLScriptElement;
    t.async = true;
    t.src = "https://www.clarity.ms/tag/" + i;
    const y = l.getElementsByTagName(r)[0];
    y.parentNode!.insertBefore(t, y);
  })(window, document, "clarity", "script", id);
}
